import { toast } from 'react-toastify';
import { notificationsApi } from 'entities/notifications';

const addDistributionApi = notificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    addDistribution: builder.mutation({
      query: ({ body }) => ({
        url: '/notifications/admin/distributions/',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили новое уведомление', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Distributions' }];
      },
    }),
  }),
});

export const { useAddDistributionMutation } = addDistributionApi;
